<section class="trust-area pt-100 pb-70 about-oman-hero">
    <div class="container">
        <div class="section-title" appReveal>
            <h2>Friendly, Safe, And Film-Ready</h2>
            <p>Oman is known for warm hospitality, cultural respect, and a calm environment that makes international teams feel comfortable from day one.</p>
            <p class="about-oman-safety">
                <strong>Safety</strong> is one of Oman's greatest strengths.
                Combined with its <strong>welcoming culture</strong>,
                <strong>political stability</strong>,
                <strong>modern infrastructure</strong>, and
                <strong>ease of travel</strong>, the country provides a
                secure and dependable environment where international
                productions can work efficiently and with complete peace of
                mind.
            </p>
        </div>

        <div *ngIf="aboutOmanLoading" class="row">
            <div class="col-sm-6 col-lg-4" *ngFor="let item of aboutOmanSkeletonItems">
                <div class="service-item skeleton">
                    <div class="service-inner">
                        <h3 class="skeleton-text skeleton-title">&nbsp;</h3>
                        <p class="skeleton-text skeleton-desc">&nbsp;</p>
                    </div>
                </div>
            </div>
        </div>

        <div *ngIf="!aboutOmanLoading && aboutOmanError" class="row">
            <div class="col-12">
                <div class="service-feedback service-error">
                    <strong>Unable to load About Oman content.</strong>
                    <span>{{ aboutOmanError }}</span>
                </div>
            </div>
        </div>

        <div *ngIf="!aboutOmanLoading && !aboutOmanError && aboutOmanItems.length === 0" class="row">
            <div class="col-12">
                <div class="service-feedback service-empty">
                    No About Oman items were returned from WordPress. Add items under WordPress and refresh this page.
                </div>
            </div>
        </div>

        <div class="row" *ngIf="!aboutOmanLoading && !aboutOmanError && aboutOmanItems.length > 0">
            <div
                class="col-sm-6 col-lg-4"
                [class.offset-sm-3]="i === aboutOmanItems.length - 1 && aboutOmanItems.length % 2 !== 0"
                [class.offset-lg-0]="i === aboutOmanItems.length - 1 && aboutOmanItems.length % 2 !== 0"
                *ngFor="let item of aboutOmanItems; trackBy: trackByAboutOman; let i = index"
                appReveal revealVariant="card" [revealDelay]="i * 90">
                <div class="service-item">
                    <div class="service-inner">
                        <h3>{{ item.title }}</h3>
                        <p *ngIf="item.description">{{ item.description }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>